.quantity-cell {
  display: flex;
  justify-content: flex-end;
}
